export default __webpack_public_path__ + "static/media/mongodb-icon.0781b723.svg";